var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-links"},_vm._l((_vm.links),function(link,i){return _c('router-link',{key:i,staticClass:"btn btn--md btn--outline",attrs:{"to":link.route}},[_c('span',[_vm._v(_vm._s(link.title))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }